import { forwardRef, ForwardRefRenderFunction } from "react";
//#region types
import { BaseFormViewComponentProps, FormHandles } from "models/propTypes/genericFormProps";
import { FileEnums } from "models/enums";
import { ShareRegisterFormTypes } from "models/formTypes";
import { TranslationKeys } from "translations";
import { TextInputProps } from "models/propTypes/wintFormPropsTypes";
import { FileConstants } from "utils/constants";
//#endregion
//#region components
import {
  TextAreaInput,
  useWintForm,
  VerticalFormField,
  WintForm,
  FileUploader,
  GroupSection,
} from "components/common/wintForms";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import { LocalizationHelperInstance } from "utils/helpers";

const ShareRegisterRejectForm: ForwardRefRenderFunction<FormHandles, BaseFormViewComponentProps> = (props, ref) => {
  const { wintFormProps, connect } = useWintForm<ShareRegisterFormTypes.Deny>({
    formRef: ref,
    defaultValues: props.defaultValues,
    validationSchema: props.validationSchema,
    handleSubmit: props.handleSubmit,
  });

  return (
    <WintForm {...wintFormProps}>
      <VerticalFormField<TextInputProps>
        Component={TextAreaInput}
        {...connect("message")}
        minRows={1}
        maxRows={3}
        label={LocalizationHelperInstance.getFormattedMessage(
          TranslationKeys.ShareRegister.ShareRegisterTodoDenyLabelText
        )}
      />
      <GroupSection
        header={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Attachments)}
        description={LocalizationHelperInstance.getFormattedMessage(
          TranslationKeys.ShareRegister.ShareRegisterTodoAttachDescriptionText
        )}
        className={cssExports.noBorder}
      >
        <VerticalFormField
          Component={FileUploader}
          {...connect("filesToUpload")}
          filePreviewElementId={FileConstants.DialogFilePreviewPortalId}
          allowedTypes={[
            FileEnums.ContentTypes.ImageJPEG,
            FileEnums.ContentTypes.ImagePNG,
            FileEnums.ContentTypes.ApplicationPDF,
          ]}
          singleSelection
        />
      </GroupSection>
    </WintForm>
  );
};

export default forwardRef(ShareRegisterRejectForm);
